import { Injectable } from '@angular/core';
import {
  BulkReviewRow,
  BulkEditValidator,
  MARGIN_UPDATE_NOT_ALLOWED_ERROR,
  SurveyMarginUpdateInspector,
  EMPTY_MARGIN_VALUE,
} from '@ps/survey-utils';

@Injectable({ providedIn: 'root' })
export class SurveyMarginValidatorService implements BulkEditValidator {
  private _message = MARGIN_UPDATE_NOT_ALLOWED_ERROR;

  public get message(): string {
    return this._message;
  }

  public isValid(row: BulkReviewRow): boolean {
    const inspector = new SurveyMarginUpdateInspector({
      isMarginOverrideEnabled: row['isMarginOverrideEnabled'] === true,
      isManualScpiOverrideEnabled: row['isManualScpiOverrideEnabled'] === true,
      isMarginMaxEnabled: row['isMarginMaxEnabled'] === true,
    });

    if (!inspector.isUpdateAllowed()) {
      this._message = MARGIN_UPDATE_NOT_ALLOWED_ERROR;
      return false;
    }

    const updatedValue = row.updatedValue as number;

    if (inspector.isValueEmpty(updatedValue)) {
      this._message = EMPTY_MARGIN_VALUE;
      return false;
    }

    return true;
  }
}
